import { render, staticRenderFns } from "./OfficeChartShipped.vue?vue&type=template&id=05353a48&"
import script from "./OfficeChartShipped.vue?vue&type=script&lang=js&"
export * from "./OfficeChartShipped.vue?vue&type=script&lang=js&"
import style0 from "./OfficeChartShipped.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports